export default __webpack_public_path__ + "static/media/more_info_corner1_01.27117490.png";